import { render, staticRenderFns } from "./DeviceUpdate.vue?vue&type=template&id=5953bf86&"
import script from "./DeviceUpdate.vue?vue&type=script&lang=js&"
export * from "./DeviceUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports